module.exports = __webpack_public_path__ + "static/img/icono-estrella.4fbf24d8.svg";